var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { get } from "lodash";
import { connect } from "@irati/store";
import Loading from "@irati/ui/src/Loading";
import { injectIntl } from "@irati/utils/lang";
import WalletActions from "@irati/wallet/store/actions/Wallet";
import { Hr } from "@irati/ui/src/Layout";
import { Row, Col } from "@irati/ui/src/ColumnRow";
import { PaymentProvider } from "@irati/types";
import basket from "@irati/checkout/utils/basket";
import { BalanceWrapper } from "./styled";
import PayByZip from "./PayByZip";
import PayByCreditCard from "./PayByCreditCard";
var PerksPaymentSelect = /** @class */ (function (_super) {
    __extends(PerksPaymentSelect, _super);
    function PerksPaymentSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            payByCard: false,
            payByWallet: false,
            payByZip: false,
            walletAmount: 0
        };
        _this.handleCardOrZip = function (value) {
            if (value === PaymentProvider.Zip) {
                _this.setState({ payByZip: true, payByWallet: false, payByCard: false }, function () { return _this.handleChange(); });
            }
            else if (value === PaymentProvider.AdyenClassic) {
                _this.setState({ payByCard: true, payByZip: false }, function () { return _this.handleChange(); });
            }
        };
        _this.handleUseWallet = function (value) {
            if (value === true) {
                // if you select wallet, it can only be partial payment with card payments, not zip
                _this.setState({ payByCard: true, payByWallet: true, payByZip: false }, function () { return _this.handleChange(); });
            }
            else {
                _this.setState({ payByWallet: false }, function () { return _this.handleChange(); });
            }
        };
        _this.handleChange = function () {
            var _a = _this.state, payByCard = _a.payByCard, payByZip = _a.payByZip, walletAmount = _a.walletAmount;
            if (payByZip) {
                basket.paymentProvider = PaymentProvider.Zip;
            }
            else {
                basket.paymentProvider = PaymentProvider.AdyenClassic;
            }
            var subscription = basket.subscribe(function (summary) {
                if (!summary.isLoading) {
                    var total = summary.breakdown.total.amount;
                    var options = [];
                    if (walletAmount) {
                        options.push({ type: PaymentProvider.Wallet, amount: walletAmount });
                        var leftOver = total - walletAmount;
                        if (leftOver > 0) {
                            options.push({ type: PaymentProvider.AdyenClassic, amount: leftOver });
                        }
                    }
                    else if (payByCard) {
                        options.push({ type: PaymentProvider.AdyenClassic, amount: total });
                    }
                    else if (payByZip) {
                        options.push({ type: PaymentProvider.Zip, amount: total });
                    }
                    _this.props.onChange(options);
                    subscription.unsubscribe();
                }
            });
        };
        _this.isZipEnabled = function () { return get(_this.props.deal, "paymentOptions.zip.enabled", false); };
        return _this;
    }
    PerksPaymentSelect.prototype.componentDidMount = function () {
        var requested = this.props.wallet.requested;
        if (!requested) {
            this.setState({ load: this.props.getWallet() });
        }
        // Default payment method to AdyenClassic (card)
        this.handleCardOrZip(PaymentProvider.AdyenClassic);
    };
    PerksPaymentSelect.prototype.render = function () {
        var _a = this.state, payByCard = _a.payByCard, load = _a.load, payByZip = _a.payByZip, payByWallet = _a.payByWallet, walletAmount = _a.walletAmount;
        var isZipEnabled = this.isZipEnabled();
        return (React.createElement(Loading, { load: load },
            React.createElement(Row, null,
                React.createElement(Col, { md: 12 },
                    React.createElement(BalanceWrapper, null,
                        React.createElement(PayByCreditCard, { walletAmount: walletAmount, currency: basket.breakdown.total.currency, isCardSelected: payByCard, isWalletSelected: payByWallet, onSelectCard: this.handleCardOrZip, onSelectWallet: this.handleUseWallet }),
                        isZipEnabled && (React.createElement(React.Fragment, null,
                            React.createElement(Hr, null),
                            React.createElement(PayByZip, { isZipSelected: payByZip, onSelectZip: this.handleCardOrZip }))))))));
    };
    PerksPaymentSelect.getDerivedStateFromProps = function (props, state) {
        var availableInWallet = props.wallet.availableBalance * 100;
        var total = basket.breakdown.total.amount;
        var walletAmount = Math.min(total, availableInWallet);
        return {
            walletAmount: state.payByWallet ? walletAmount : 0
        };
    };
    return PerksPaymentSelect;
}(PureComponent));
var mapStateToProps = function (_a) {
    var wallet = _a.wallet;
    return ({
        wallet: wallet
    });
};
var mapDispatchToProps = function (dispatch) {
    return {
        getWallet: function () { return dispatch(WalletActions.get()); }
    };
};
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(PerksPaymentSelect));
